(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tz-creator-featured-product"] && !Shopify.designMode) return;
  try {
    
function tzCfpSwitchImage(thumb, sectionId) {
  var mainImg = document.getElementById('tz_cfp_main_img_' + sectionId);
  if (!mainImg) return;
  mainImg.src = thumb.dataset.src;
  var thumbs = thumb.closest('.tz-cfp-product-thumbnails').querySelectorAll('.thumb');
  thumbs.forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tz-creator-why-choose"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    /* ── Worker proxy URL ── */
    var WORKER_URL = 'https://tz-zendesk.veno-scorp.workers.dev';

    /* ── Submit to Worker proxy (avoids CORS, no token in browser) ── */
    function submitToWorker(payload) {
      return fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || 'HTTP ' + res.status);
          return data;
        });
      });
    }

    /* ── Main submit handler ── */
    function handleSubmit(e) {
      e.preventDefault();
      clearBanner();

      if (!validate()) return;

      var name = nameEl.value.trim();
      var email = emailEl.value.trim();
      var phone = phoneEl ? phoneEl.value.trim() : '';
      var instagram = instagramEl ? instagramEl.value.trim() : '';
      var youtube = youtubeEl ? youtubeEl.value.trim() : '';
      var tiktok = tiktokEl ? tiktokEl.value.trim() : '';
      var turnstileTokenEl = form.querySelector('[name="cf-turnstile-response"]');
      var turnstileToken = turnstileTokenEl ? turnstileTokenEl.value : '';

      setBusy(true);
      showBanner('info');

      submitToWorker({
        email: email,
        name: name,
        tag: 'venoscorp-creator',
        subject: 'Creator Application \u2013 ' + name,
        turnstileToken: turnstileToken,
        fields: [
          { label: 'Name', value: name },
          { label: 'Email', value: email },
          { label: 'Phone', value: phone || 'Not provided' },
          { label: 'Instagram', value: instagram || 'Not provided' },
          { label: 'YouTube', value: youtube || 'Not provided' },
          { label: 'TikTok', value: tiktok || 'Not provided' },
        ],
      })
        .then(function (res) {
          setBusy(false);
          if (res.success) {
            BANNER_CONFIG.error.subtitle =
              'Your application could not be sent. Check your details and try again, or contact us directly if the issue persists.';
            showBanner('success');
            form.reset();
            resetTurnstile();
          } else {
            throw new Error(res.error || 'Unexpected response');
          }
        })
        .catch(function (err) {
          setBusy(false);
          BANNER_CONFIG.error.subtitle =
            'Your application could not be submitted. Please try again in a moment or contact us directly.';
          showBanner('error');
          resetTurnstile();
          console.error('[TZ Creator CTA] Worker error:', err);
        });
    }

    /* ── DOM refs ── */
    var form = document.getElementById('tz-creator-cta-form');
    var nameEl = document.getElementById('tz-creator-cta-name');
    var emailEl = document.getElementById('tz-creator-cta-email');
    var phoneEl = document.getElementById('tz-creator-cta-phone');
    var instagramEl = document.getElementById('tz-creator-cta-instagram');
    var youtubeEl = document.getElementById('tz-creator-cta-youtube');
    var tiktokEl = document.getElementById('tz-creator-cta-tiktok');
    var submitBtn = document.getElementById('tz-creator-cta-submit');
    var bannerSurface = document.getElementById('tz_creator_banner_surface');
    var banner = document.getElementById('tz_creator_banner');
    var bannerIconWrap = document.getElementById('tz_creator_banner_icon_wrap');
    var bannerTag = document.getElementById('tz_creator_banner_tag');
    var bannerTitle = document.getElementById('tz_creator_banner_title');
    var bannerSubtitle = document.getElementById('tz_creator_banner_subtitle');
    var bannerProgress = document.getElementById('tz_creator_banner_progress');
    var bannerCloseBtn = banner ? banner.querySelector('.tz-banner-close-btn') : null;

    if (!form) return;

    /* ── SVG icons ── */
    var ICON_SUCCESS =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e50000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    var ICON_ERROR =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#eb212d" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    var ICON_INFO =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12" y2="16"/></svg>';

    /* ── Banner content config per type ── */
    var BANNER_CONFIG = {
      success: {
        tagText: 'Application received',
        title: 'Thanks! Your creator application is in.',
        subtitle: "We'll review your details and get back to you soon.",
        icon: ICON_SUCCESS,
        showProgress: true,
      },
      error: {
        tagText: 'Submission failed',
        title: 'Something went wrong \u2014 please try again.',
        subtitle:
          'Your application could not be sent. Check your details and try again, or contact us directly if the issue persists.',
        icon: ICON_ERROR,
        showProgress: false,
      },
      info: {
        tagText: 'Processing\u2026',
        title: 'Sending your application',
        subtitle: 'Please hold on, this only takes a moment.',
        icon: ICON_INFO,
        showProgress: false,
      },
    };

    /* ── Show banner ── */
    function showBanner(type) {
      var cfg = BANNER_CONFIG[type] || BANNER_CONFIG.info;
      banner.className = 'tz-banner tz-banner-' + type;
      bannerIconWrap.className = 'tz-banner-icon-wrap';
      bannerIconWrap.innerHTML = cfg.icon;
      bannerTag.className = 'tz-banner-tag';
      bannerTag.textContent = cfg.tagText;
      bannerTitle.textContent = cfg.title;
      bannerSubtitle.textContent = cfg.subtitle;
      if (cfg.showProgress) {
        bannerProgress.style.display = '';
        var fill = bannerProgress.querySelector('.tz-banner-progress-fill');
        var clone = fill.cloneNode(true);
        fill.parentNode.replaceChild(clone, fill);
        setTimeout(function () {
          banner.classList.add('tz-banner-animate');
        }, 20);
      } else {
        bannerProgress.style.display = 'none';
        banner.classList.remove('tz-banner-animate');
      }
      bannerSurface.classList.add('tz-banner-visible');
      bannerSurface.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ── Hide banner ── */
    function clearBanner() {
      bannerSurface.classList.remove('tz-banner-visible');
      banner.classList.remove('tz-banner-animate');
    }

    /* ── Dismiss on close button ── */
    if (bannerCloseBtn) {
      bannerCloseBtn.addEventListener('click', clearBanner);
    }

    /* ── Button busy state ── */
    var originalLabel = submitBtn ? submitBtn.textContent.trim() : '';
    function setBusy(busy) {
      submitBtn.disabled = busy;
      submitBtn.textContent = busy ? 'Sending\u2026' : originalLabel;
    }

    /* ── Input error helpers ── */
    function markError(el) {
      el.classList.add('tz-input-error');
    }
    function clearErrors() {
      [nameEl, emailEl, phoneEl, instagramEl, youtubeEl, tiktokEl].forEach(function (el) {
        if (el) el.classList.remove('tz-input-error');
      });
    }

    /* ── Email format check ── */
    function isValidEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
    }

    /* ── Client-side validation ── */
    function validate() {
      clearErrors();

      if (!nameEl.value.trim()) {
        markError(nameEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your name.';
        showBanner('error');
        nameEl.focus();
        return false;
      }

      var email = emailEl.value.trim();
      if (!email) {
        markError(emailEl);
        BANNER_CONFIG.error.subtitle = 'Please enter your email address.';
        showBanner('error');
        emailEl.focus();
        return false;
      }

      if (!isValidEmail(email)) {
        markError(emailEl);
        BANNER_CONFIG.error.subtitle =
          'That doesn\u2019t look like a valid email address. Please double-check and try again.';
        showBanner('error');
        emailEl.focus();
        return false;
      }

      /* ── Turnstile token check ── */
      var turnstileToken = form.querySelector('[name="cf-turnstile-response"]');
      if (!turnstileToken || !turnstileToken.value) {
        BANNER_CONFIG.error.subtitle = 'Please complete the CAPTCHA verification before submitting.';
        showBanner('error');
        return false;
      }

      return true;
    }

    /* ── Reset Turnstile widget ── */
    function resetTurnstile() {
      if (window.turnstile) {
        var widgetEl = document.getElementById('tz-creator-cta-turnstile');
        if (widgetEl && widgetEl._turnstileWidgetId !== undefined) {
          window.turnstile.reset(widgetEl._turnstileWidgetId);
        } else {
          window.turnstile.reset();
        }
      }
    }

    /* ── Live clear on user correction ── */
    [nameEl, emailEl, instagramEl, youtubeEl, tiktokEl].forEach(function (el) {
      if (el)
        el.addEventListener('input', function () {
          el.classList.remove('tz-input-error');
          clearBanner();
        });
    });

    /* ── Phone: digits only + live clear ── */
    if (phoneEl) {
      phoneEl.addEventListener('input', function () {
        phoneEl.classList.remove('tz-input-error');
        clearBanner();
        var cleaned = phoneEl.value.replace(/\D/g, '');
        if (phoneEl.value !== cleaned) {
          var pos = phoneEl.selectionStart - (phoneEl.value.length - cleaned.length);
          phoneEl.value = cleaned;
          phoneEl.setSelectionRange(pos, pos);
        }
      });
    }

    form.addEventListener('submit', handleSubmit);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tz-product-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq-section]').forEach(function (section) {
      var items = section.querySelectorAll('.accordion-item');
      items.forEach(function (item) {
        var header = item.querySelector('.accordion-header');
        header.addEventListener('click', function () {
          items.forEach(function (i) {
            if (i !== item) i.classList.remove('active');
          });
          item.classList.toggle('active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tz-product-gaming-case"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-id]').forEach(function (sectionEl) {
      sectionEl.querySelectorAll('.tz-gaming-case-item').forEach(function (item) {
        item.addEventListener('click', function () {
          item.classList.toggle('active');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
